import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { SESSION_STORAGE_KEYS } from 'common/constants/constants';

const BLACK_LISTED_REDIRECT_PATHS = ['/callback', '/login', '/register'];

const RedirectorHOC = ({ children }) => {
  const history = useHistory();
  const sessionStorageAccessor = BrowserStorageAccessor().session;
  useEffect(() => {
    const redirectTo = sessionStorageAccessor.get(
      SESSION_STORAGE_KEYS.REDIRECT_TO
    );

    if (redirectTo) {
      sessionStorageAccessor.remove(SESSION_STORAGE_KEYS.REDIRECT_TO);
      const [pathname, search] = redirectTo.split('?');
      const isBlackListed = BLACK_LISTED_REDIRECT_PATHS.some(uri =>
        redirectTo.includes(uri)
      );

      if (isBlackListed) {
        return;
      }
      history.replace({
        pathname,
        search
      });
    }
  }, []);
  return <>{children}</>;
};

export default RedirectorHOC;
